<div class="charging-page" *ngIf="!isTransactionStopped; else thankYouTemplate">
  <header class="charging-header">
    <a class="brand" href="/">
      <img *ngIf="tenantLogo" class="brand-logo" [src]="tenantLogo" alt="">
      <ng-container *ngIf="!tenantLogo"><mat-icon>bolt</mat-icon><span>{{ tenantName || ('qrcode.brand' | translate) }}</span></ng-container>
    </a>
    <div class="header-right">
      <div class="header-title"><mat-icon>ev_station</mat-icon><span>{{'Charging.charging' | translate}}</span></div>
      <div class="lang-selector">
        <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
      </div>
    </div>
  </header>

  <main class="charging-main">
    <section class="station-heading">
      <div>
        <span class="session-status" [class.is-active]="transactionId"><span></span>{{ (transactionId ? 'Charging.charging' : 'qrcode.charging_Station') | translate }}</span>
        <h1>{{ chargingStation?.id || chargingStationId }}</h1>
        <div class="station-meta">
          <span><mat-icon>location_on</mat-icon>{{ chargingStation?.site?.address?.address1 || '-' }}</span>
          <span><mat-icon>ev_station</mat-icon>{{'qrcode.connector' | translate}} {{ connectorId }} <ng-container *ngIf="connectorStatus">({{ connectorStatus }})</ng-container></span>
        </div>
      </div>
    </section>

    <section class="waiting-layout" *ngIf="!transactionId">
      <article class="waiting-card">
        <div class="waiting-icon"><mat-icon>bolt</mat-icon></div>
        <h2>{{'Charging.charging' | translate}}</h2>
        <p>{{'qrcode.charging_wait_desc' | translate}}</p>
        <button mat-flat-button class="start-button" [disabled]="transactoinStarted" (click)="startTransaction()">
          <mat-spinner diameter="20" *ngIf="transactoinStarted"></mat-spinner>
          <span *ngIf="!transactoinStarted">{{'Charging.start' | translate}}</span>
          <mat-icon *ngIf="!transactoinStarted">play_circle</mat-icon>
        </button>
      </article>
      <article class="station-detail-card">
        <span>{{'Charging.charging_Details' | translate}}</span>
        <div><mat-icon>ev_station</mat-icon><p><small>{{'qrcode.charging_Station' | translate}}</small><strong>{{ chargingStationId || '-' }}</strong></p></div>
        <div><mat-icon>power</mat-icon><p><small>{{'qrcode.connector' | translate}}</small><strong>{{ connectorId }} - {{ connectorStatus || '-' }}</strong></p></div>
        <div><mat-icon>location_on</mat-icon><p><small>{{'Charging.location' | translate}}</small><strong>{{ chargingStation?.site?.address?.address1 || '-' }}</strong></p></div>
      </article>
    </section>

    <section class="charging-dashboard" *ngIf="transactionId">
      <article class="charge-ring-card">
        <div class="energy-wrap">
          <mat-icon>energy_savings_leaf</mat-icon>
          <strong>{{ energyInKWh | number:'1.2-2' }} <small>kWh</small></strong>
          <span>{{'Charging.delivered' | translate}}</span>
        </div>
        <div class="live-chips">
          <span><i></i>{{'Charging.charging' | translate}}</span>
        </div>
      </article>

      <section class="charging-stats">
        <article class="cost-card">
          <div class="stat-heading"><span class="stat-icon blue"><mat-icon>payments</mat-icon></span><span>{{'Charging.price' | translate}}</span></div>
          <div class="cost-value">{{ transactionDetails?.currentCumulatedRoundedPrice }} <small>{{ transactionDetails?.priceUnit || '€' }}</small></div>
          <div class="cost-line"><span></span></div>
        </article>

        <div class="split-stats">
          <article class="metric-card"><mat-icon>schedule</mat-icon><span>{{'Charging.duration' | translate}}</span><strong>{{ formattedDuration }}</strong></article>
          <article class="metric-card"><mat-icon>bolt</mat-icon><span>{{'Charging.delivered' | translate}}</span><strong>{{ energyInKWh | number:'1.2-2' }} kWh</strong></article>
        </div>

        <button mat-flat-button class="stop-button" (click)="stopTransaction(dialogService, translateService)"><mat-icon>stop_circle</mat-icon>{{'Charging.stop' | translate}}</button>
      </section>
    </section>

    <section class="session-details" *ngIf="transactionId && transactionDetails">
      <div><span>{{'Charging.charging_Details' | translate}}</span><strong>#{{ transactionDetails.id }}</strong></div>
      <div><span>{{'qrcode.charging_Station' | translate}}</span><strong>{{ transactionDetails.chargeBoxID }}</strong></div>
      <div><span>{{'qrcode.connector' | translate}}</span><strong>{{ transactionDetails.connectorId }}</strong></div>
      <div><span>{{'Charging.location' | translate}}</span><strong>{{ chargingStation?.site?.address?.address1 || '-' }}</strong></div>
    </section>
  </main>
</div>

<ng-template #thankYouTemplate>
  <div class="thank-you-page">
    <header class="charging-header">
      <a class="brand" href="/">
        <img *ngIf="tenantLogo" class="brand-logo" [src]="tenantLogo" alt="">
        <ng-container *ngIf="!tenantLogo"><mat-icon>bolt</mat-icon><span>{{ tenantName || ('qrcode.brand' | translate) }}</span></ng-container>
      </a>
      <div class="header-right">
        <div class="lang-selector">
          <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
          <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
        </div>
      </div>
    </header>
    <main class="thank-you-content">
      <div class="thank-you-card">
        <mat-icon>check_circle</mat-icon>
        <h1>{{'Charging.thankyou' | translate}}</h1>
        <p class="thank-you-subtitle">{{'Charging.sessioFinished' | translate}}</p>
        <button mat-flat-button class="primary-action" [disabled]="isLoadingInvoice || !invoiceUrl" (click)="ViewInvoice()">
          <mat-spinner diameter="18" *ngIf="isLoadingInvoice"></mat-spinner>
          <span *ngIf="!isLoadingInvoice">{{'Charging.ViewInvoice' | translate}}</span>
        </button>
      </div>
    </main>
  </div>
</ng-template>
